export enum Locale {
  en = 'en',
}

export type LocalizeProps = {
  id: string;
  locale?: Locale;
};
